<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="disabled ? '387px' : '350px'"
      border
      :edit-rules="validRules"
    >
      <template v-slot:top>
        <div class="side-frame">
          <span class="side-frame-text">
            {{ $l('table_title_quoted_spec') || '规格报价' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('btn_add_spec') || '增加规格' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    disabled: { type: Boolean, default: false },
    tskQuotedGoodsCode: { type: String, default: '' },
    depCode: { type: String, default: '' },
    orgDepFullName: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      validRules: {
        quotedSampleSpec: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        quotedMoq: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        quotedCasePack: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: this.$l('tips_quotedCasePack_than_0') || '装箱入数须大于0',
          },
        ],
        quotedPrice: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_quotedPrice_than_0') || '报价产品单价须大于0',
          },
        ],
      },
    }
  },
  methods: {
    loadData() {
      if (!this.tskQuotedGoodsCode) return
      this.$api
        .personalTskQuotedGoodsSpecListApi({
          tskQuotedGoodsCode: this.tskQuotedGoodsCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt({}, -1)
      await $itemTable.setActiveCell(newRow, 'quotedSampleSpec')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true).catch(() => true)
      return !result
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
    },
  },
}
</script>
